import React from 'react';
import PropTypes from 'prop-types';

import { CsvPreview, HeadersList } from '../Shared';
import AdminActionButton from '../../../shared/Buttons/AdminActionButton';
import { t } from '../../../../../modules/infra/i18n';
import Icon, { GLYPHS } from '../../../../common/icon';

const csvHeaders = [
  'Date*', 'Time*', 'Duration*', 'Service Name*', 'Staff First Name*', 'Staff Last Name*',
  'Client First Name*', 'Client Last Name*', 'Phone*', 'Email*', 'Frequency*',
];

const AppointmentsImport = ({
  onChange,
  preview,
  onSubmit,
  importResults,
  deleteAppointments,
  busy,
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt" display-if={importResults}>
        <ul>
          {importResults.map((result, i) => <li key={i}>{result}</li>)}
        </ul>
      </div>
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={onSubmit}>
          <div className="layout">
            <div className="layout__item u-1/2 u-p-0">
              <div className="layout__item">
                <label className="c-file-input">
                  <div className="c-file-input__empty">
                    <Icon glyph={GLYPHS.upload} className="c-icon u-mr--" />
                    <span className="u-align-middle">{t('admin:import.appointments.choose_file_button')}</span>
                  </div>
                  <input
                    type="file"
                    onChange={onChange}
                    name="csv"
                    accept=".csv"
                  />
                </label>
              </div>
              <div className="layout__item u-6/7">
                <AdminActionButton
                  type="submit"
                  className="c-btn c-btn--medium u-width-100"
                  disabled={busy || !preview}
                >
                  {t('admin:import.appointments.import_button')}
                </AdminActionButton>
              </div>
              <div className="layout__item u-6/7">
                <AdminActionButton 
                  type="button" 
                  className="c-btn c-btn--medium u-width-100" 
                  onClick={deleteAppointments}
                >
                  {t('admin:import.appointments.wipe_button')}
                </AdminActionButton>
              </div>
            </div>
            <HeadersList
              className="layout__item u-1/2"
              fields={csvHeaders}
            />
          </div>
        </form>
        <CsvPreview display-if={preview} preview={preview} />
      </div>
    </div>
  </div>
);

AppointmentsImport.propTypes = {
  onChange: PropTypes.func.isRequired,
  deleteAppointments: PropTypes.func.isRequired,
  preview: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  importResults: PropTypes.array,
  busy: PropTypes.bool,
};

AppointmentsImport.defaultProps = {
  preview: null,
  importResults: null,
  busy: false,
};

export default AppointmentsImport;
